// extracted by mini-css-extract-plugin
export var carrierTab = "_45-0";
export var carrierTabActive = "_45-1 _45-0";
export var carrierTabInactive = "_45-2 _45-0";
export var carrierTabLabel = "_45-3";
export var carrierTabLabelActive = "_45-4 _45-3";
export var carrierTabLabelInactive = "_45-5 _45-3";
export var carrierTabPercentage = "_45-6";
export var carrierTabPercentageActive = "_45-7 _45-6";
export var carrierTabPercentageInactive = "_45-8 _45-6";
export var carrierTabWinnable = "_45-9";
export var carrierTabWinnableActive = "_45-a _45-9";
export var carrierTabWinnableInactive = "_45-b _45-9";
export var comparisonContainer = "_45-d";
export var missingRateButton = "_45-n";
export var missingRateButtonActive = "_45-o _45-n";
export var missingRateButtonInactive = "_45-p _45-n";
export var missingRateButtonLabel = "_45-q";
export var missingRateButtonLabelActive = "_45-r _45-q";
export var missingRateButtonLabelInactive = "_45-s _45-q";
export var sidebar = "_45-c";
export var strategyButton = "_45-e";
export var strategyButtonActive = "_45-f _45-e";
export var strategyButtonDescription = "_45-k";
export var strategyButtonDescriptionActive = "_45-l _45-k";
export var strategyButtonDescriptionInactive = "_45-m _45-k";
export var strategyButtonInactive = "_45-g _45-e";
export var strategyButtonLabel = "_45-h";
export var strategyButtonLabelActive = "_45-i _45-h";
export var strategyButtonLabelInactive = "_45-j _45-h";
export var unitToggleButton = "_45-t";
export var unitToggleButtonActive = "_45-u _45-t";
export var unitToggleButtonInactive = "_45-v _45-t";
export var unitToggleButtonLabel = "_45-w";
export var unitToggleButtonLabelActive = "_45-x _45-w";
export var unitToggleButtonLabelInactive = "_45-y _45-w";